import { AuthSevices } from '../../../../api/src/lib/auth.service';
import { TENANTS_INFO } from 'apps/ff-frontend/src/app/state/app.state';
import { select, Store } from '@ngrx/store';
import { filter, first, Observable, tap } from 'rxjs';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
@Injectable({
  providedIn: 'root'
})
export class TenantResolverService implements Resolve<any> {

  constructor(private store:Store,private router: Router) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):Observable<any>{
    return this.store.pipe(
      select(TENANTS_INFO),
      tap((loaded)=>{
        //this.store.dispatch(SET_CLAIMS_DETAILS({claims: this.authService.parseDecodedToken}));
        if(loaded && loaded?.selected_tenant?.id == 0){
          // console.log('callingg')
        // this.store.dispatch({type: 'FETCHED_TENANT_LIST'});
        }
      }),
      filter((loaded:any) => {
        if(loaded?.selected_tenant?.status && loaded?.selected_tenant?.status.toLowerCase() == 'active'){
          return loaded?.selected_tenant?.id > 0 ?  true : false;
        }
        else{
          // if(loaded?.selected_tenant?.status && loaded?.selected_tenant?.status.toLowerCase() == 'inactive')
          // {
          //   console.log('inactive tenant');
          // }
            //this.router.navigate(['/tenant-not-found']);
          return loaded?.selected_tenant?.id > 0 ?  true : false;
        }
      }),
      first()
    )
  }
}
